<template>
    <div class="box">
        <Titlebar
                :title="'扫码开门'"/>

        <video id="video" class="qrcode-video"/>

        <div class="note">
            请对准主控二维码扫描，开锁后自动上传测试视频
        </div>
        <video-device-error placeholder="输入主控码" v-model="visible" prefix="https://machine.goldbox.vip/"
                            @submit="onDecode"/>
    </div>
</template>

<script>


    import Titlebar from "./Titlebar.vue"
    import videoDeviceError from "./videoDeviceError";

    import {isBoxNumber, parseBoxNumber} from "../util/utils.js"
    import {checkDoorStatus} from "../util/door.js"
    import {scanQrCode} from '../util/qrcode.js';

    export default {
        name: 'OpenDoor',
        data() {
            return {
                visible: false
            }
        },
        props: {},
        components: {
            Titlebar,
            videoDeviceError
        },
        mounted() {
            scanQrCode("video", this.onDecode, () => {
                this.visible = true;
            })
        },
        methods: {
            onDecode(boxNumber) {
                if (isBoxNumber(boxNumber)) {
                    this.tryOpenDoor(parseBoxNumber(boxNumber))
                } else {
                    sessionStorage.setItem("openDoor", "failed")
                    sessionStorage.setItem("openDoorFailedReason", "请扫描主控二维码")
                    this.$router.go(-1)
                }
            },
            tryOpenDoor(boxNumber) {
                var that = this

                checkDoorStatus(
                    boxNumber,
                    function (boxNumber) {
                        /* Add 2 seconds delay to open door */
                        setTimeout(function () {
                            that.openDoor(boxNumber)
                        }, 2000)
                    },
                    function (errorInfo) {
                        sessionStorage.setItem("openDoorFailedInfo", errorInfo)
                        that.$router.push("/openDoorFailed")
                    },
                    function (notifyText) {
                        sessionStorage.setItem("openDoor", "failed")
                        sessionStorage.setItem("openDoorFailedReason", notifyText)
                        that.$router.go(-1)
                    }
                )
            },
            openDoor(boxNumber) {
                var url = process.env.VUE_APP_API_SERVER + '/box/' + boxNumber + "/open-door"
                var accessToken = localStorage.getItem('accessToken')

                var that = this
                fetch(url, {
                    method: "POST",
                    headers: new Headers({
                        'Content-Type': 'application/json',
                        'Access-Token': accessToken
                    })
                }).then(res => {
                    if (!res.ok) {
                        throw res
                    }
                    return res.json()
                }).catch(error => {
                    sessionStorage.setItem("openDoor", "failed")
                    sessionStorage.setItem("openDoorFailedReason", error)
                    that.$router.go(-1)
                }).then(response => {
                    if (response.Status == 0) {
                        sessionStorage.setItem("openDoor", "success")
                        that.$router.go(-1)
                    } else if (response.Status == 1) {
                        sessionStorage.setItem("openDoor", "failed")
                        sessionStorage.setItem("openDoorFailedReason", "门已经打开了")
                        that.$router.go(-1)
                    } else if (response.Status == 2) {
                        sessionStorage.setItem("openDoor", "failed")
                        sessionStorage.setItem("openDoorFailedReason", "开门超时")
                        that.$router.go(-1)
                    } else if (response.Status == 3) {
                        sessionStorage.setItem("openDoor", "failed")
                        sessionStorage.setItem("openDoorFailedReason", "开门失败")
                        that.$router.go(-1)
                    } else if (response.Status == 4) {
                        sessionStorage.setItem("openDoor", "failed")
                        sessionStorage.setItem("openDoorFailedReason", "设备离线")
                        that.$router.go(-1)
                    } else if (response.Status == 5) {
                        sessionStorage.setItem("openDoor", "failed")
                        sessionStorage.setItem("openDoorFailedReason", "服务器错误, 错误码: " + response.Status)
                        that.$router.go(-1)
                    }
                })
            }
        }
    }
</script>

<style scoped>
    .note {
        margin-top: 20px;
        font-size: 20px;
        color: #666;
    }

    .box {
        width: 100%;
        height: 100%;
    }

    .qrcode-video {
        width: 100%;
        height: 50%;
        background-color: black;
    }
</style>
